module.exports = __webpack_public_path__ + "img/2024121001.bf72ad89.png";